import { rem, Bold, getColorByKind, border } from '@core-web/typography';
import { styled, Box } from '@mui/material';
import { ITypography } from '../types/ITypography';

const StyledHeader = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'showSeparator',
})<ITypography>(({ theme: { palette }, kind, showSeparator }) => ({
  fontSize: rem(16),
  fontWeight: Bold._600,
  lineHeight: rem(22),
  color: getColorByKind(kind, palette),
  ...(showSeparator && {
    borderBottom: border(1, 'solid', palette.colors.grey_900),
    paddingBottom: rem(8),
  }),
}));

export const HeaderMedium = ({ title, kind, ...rest }: ITypography): JSX.Element => (
  <StyledHeader kind={kind} title={title} {...rest}>
    {title}
  </StyledHeader>
);
